import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

// import css
import "./questionBlock.css";
export const QuestionBlock = (props) => {
  const [showp, setShowp] = useState(false);
  const [showplusicon, setplusicon] = useState(true);
  const [showminusicon, setminusicon] = useState(false);
  const shwoparagraph = () => {
    setShowp(true);
    setplusicon(false);
    setminusicon(true);
  };
  const hideparagraph = () => {
    setShowp(false);
    setplusicon(true);
    setminusicon(false);
  };
  return (
    <>
      <div className="question">
        <h4>
          {showminusicon && <AiOutlineMinus onClick={hideparagraph} />}
          {showplusicon && <AiOutlinePlus onClick={shwoparagraph} />}
          {props.question}
        </h4>
        {showp && <p>{props.answer}</p>}
      </div>
    </>
  );
};
